import React from "react";

export type NotificationProps = {
  /** number of notifications; when > 0 the red circle will be shown */
  count?: number;
  /** size in px for width/height of the svg (default 24) */
  size?: number;
  /** optional className for styling */
  className?: string;
  /** accessible label */
  ariaLabel?: string;
  /** show indicator when there are unread items but no count */
  hasUnread?: boolean;
};

const NotificationIcon: React.FC<NotificationProps> = ({
  count = 0,
  size = 24,
  className,
  ariaLabel = "Notifications",
  hasUnread = false,
}) => {
  // create a stable unique id for the clipPath so multiple icons don't clash
  const generatedId = React.useId().replace(/:/g, "");
  const clipId = `clip-notification-${generatedId}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-label={ariaLabel}
      role="img"
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {count > 0 ? (
          <>
            <circle
              cx="16.2002"
              cy="7"
              r="8"
              fill="var(--tlx-status-error-text)"
              stroke="var(--tlx-cta-primary-default)"
            />
            <text
              x="16"
              y="7"
              textAnchor="middle"
              dominantBaseline="middle"
              fill="var(--tlx-surface-bg-surface)"
              fontSize="8"
              fontWeight="500"
            >
              {count}
            </text>
          </>
        ) : (
          hasUnread && (
            <circle
              cx="16.2002"
              cy="4"
              r="4"
              fill="var(--tlx-status-error-text)"
            />
          )
        )}

        <path
          d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="var(--tlx-surface-bg-surface)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NotificationIcon;
